var map = {
	"./announcement/Handler": 85389,
	"./auth/Handler": 25496,
	"./common/Handler": 46407,
	"./course/Handler": 61883,
	"./document/Handler": 96363,
	"./forum/Handler": 67903,
	"./guest/Handler": 37462,
	"./home/Handler": 83449,
	"./message/Handler": 95861,
	"./newsLetter/Handler": 67193,
	"./notification/Handler": 76605,
	"./profile/Handler": 39483,
	"./promoCode/Handler": 28648,
	"./questions/Handler": 83215,
	"./quizes/Handler": 63267,
	"./reports/Handler": 25989,
	"./review/Handler": 9186,
	"./students/Handler": 18414,
	"./users/Handler": 84434,
	"./video/Handler": 16773,
	"./webinar/Handler": 39940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 33604;